<template>
  <div class="animated fadeIn">

      <b-card class="card-accent-info" header="Contagem">
          <b-card-body>
      
          <b-row>
              <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                      v-model="filters.companyId"
                      :plain="true"
                      :options="companyDDL"
                      @change="changeCompany"
                      :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
              
              </b-col>

              <b-col cols="auto">
              <b-form-group>
                  <label for="inventory" style="font-size: 0.8em">Inventário</label>
                  <b-form-select id="inventory"
                      v-model="filters.inventoryId"
                      :plain="true"
                      :options="inventoryDDL"
                      :value="[null,'c']"
                      v-on:change="changeInventory()"
                      >
                  </b-form-select>
              </b-form-group>
              
              </b-col>


            
          </b-row>
          </b-card-body>

          <b-card class="card-accent-info" header="Contagem de Peças">
              <b-card-body>

                <b-row>
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label="Etiqueta"
                      label-for="label"
                      :label-cols="2"
                      :horizontal="true">
                
                      <b-row>
                        <b-col sm="4">
                          <b-input-group>
                            <b-form-input v-model="currentLabel" type="text" id="labelFilter" placeholder=""
                            @blur="getLabel(currentLabel)"
                            ></b-form-input>
                            <!--
                            <b-input-group-append>
                              <b-button variant="primary" @click="getLabel(currentLabel)"><i class="fa fa-search"></i> Localizar</b-button>
                            </b-input-group-append>
                            -->
                          </b-input-group>
                        </b-col>
                        <b-col>

                        </b-col>
                        <b-col sm="2" class="text-right">
                            Contagem:
                        </b-col>
                        <b-col sm="2">
                            <b-form-input type="text" id="labelFilter" readonly :value="selectedItem ? ( selectedItem.statusId==3 ? '2' : ( selectedItem.statusId==4 ? '3' : ( selectedItem.statusId==1 ? '1' : 'F') ) ) : ''"></b-form-input>
                        </b-col>
                      </b-row>


                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>


                <b-row>
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label="Usuário"
                      label-for="userName"
                      :label-cols="2"
                      :horizontal="true">
                
                      <b-row>
                        <b-col sm="4">
                            <b-form-input v-model="$store.state.currentUser.username" type="text" id="labelFilter" readonly></b-form-input>
                        </b-col>
                        <b-col>
                            <b-form-input v-model="$store.state.currentUser.name" id="userName" type="text" readonly></b-form-input>
                        </b-col>
                      </b-row>

                      
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                
                <b-row>
                  <b-col>

                    <b-form>
                      <b-form-group
                      description=""
                      label="Setor: "
                      label-for="Setor"
                      :label-cols="2"
                      :horizontal="true">
                      
                        <b-row>
                          <b-col>
                              <b-form-input id="sectorName" type="text" readonly :value="selectedItem ? selectedItem.locationName : ''"></b-form-input>
                          </b-col>
                          <b-col md="2" lg="2" xl="1" class="text-right">
                            Operação:
                          </b-col>
                          <b-col sm="2">
                            <b-form-input type="text" id="opName" :value="selectedItem ? selectedItem.operationName : ''" readonly></b-form-input>
                          </b-col>                          
                        </b-row>

                      </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>
              
                <b-row>
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label="Item"
                      label-for="productCode"
                      :label-cols="2"
                      :horizontal="true">
                      
                      <b-row>
                          <b-col>
                            <b-input-group>
                              <b-form-input id="productCode" type="text" placeholder="" :value="selectedItem.product ? selectedItem.product.code : ''" readonly></b-form-input>
                            </b-input-group>

                          </b-col>
                          <b-col  md="2" lg="2" xl="1" class="text-right">
                            U/M:
                          </b-col>
                          <b-col sm="2">
                              <b-form-input type="text" id="productUM" readonly :value="selectedItem.product ? selectedItem.product.umName : ''"></b-form-input>
                          </b-col>        
                        </b-row>
                        
                      </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                
                <b-row>
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label=""
                      label-for="productName"
                      :label-cols="2"
                      :horizontal="true">
                      
                        <b-row>
                          <b-col>
                              <b-form-input id="productName" type="text" readonly :value="selectedItem.product ? selectedItem.product.name : ''"></b-form-input>
                          </b-col>                        
                        </b-row>

                      </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>


                <b-row v-show="selectedItem.series">
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label="Serial"
                      label-for="series"
                      :label-cols="2"
                      :horizontal="true">
                      <b-row>
                        <b-col sm="4">
                          <b-form-input v-model="selectedItem.series" id="series" type="text" placeholder="Série"></b-form-input>
                        </b-col>
                      </b-row>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form>
                      <b-form-group
                      description=""
                      label="Quantidade"
                      label-for="count"
                      :label-cols="2"
                      :horizontal="true">
                      <b-row>
                        <b-col>
                          <!--
                          <b-form-input v-model="selectedItem.count" id="count" type="number" min="1" step="1" oninput="validity.valid||(value='');"></b-form-input>
                          -->
                          <b-form-input v-model="selectedItem.count" id="count" type="number" min="1" step="0.1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || event.charCode==46 || event.charCode==44 || (event.charCode >= 48 && event.charCode <= 57))"></b-form-input>
                        </b-col>
                       

                      </b-row>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <div slot="footer" class="text-right">
                <!--
                  <b-button variant="html5" class="mr-1 btn-brand" @click="closeCancelModal()"><i class="fa fa-close"></i><span>Fechar</span></b-button>
                -->
                  <b-button variant="github" class="mr-1 btn-brand" @click="saveIdentification()" :disabled="incompleteFields"><i class="fa fa-save"></i><span>Salvar Contagem</span></b-button>
                </div>
                
              </b-card-body>
          </b-card>

          
          </b-card>
        
    

    <b-card class="card-accent-info" header="Últimas Contagens">
      <b-card-body>
    
        <b-row>
       
          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Etiqueta</label>
                <b-form-input v-model="filters.label" type="text" id="labelFilter" placeholder="Etiqueta"></b-form-input>
  
            </b-form-group>
          </b-col>

          <b-col cols="auto">
            <b-form-group>
                <label for="name" style="font-size: 0.8em">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="auto">
              <b-form-group>
                  <label for="sector" style="font-size: 0.8em">Setor</label>
                  <b-form-select id="sector"
                      v-model="filters.sectorId"
                      :plain="true"
                      :options="selectSectorDDL"
                      :value="[null,'c']">
                  </b-form-select>
                  
              </b-form-group>
          </b-col>

          <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Operação</label>
                  <b-form-select id="operation"
                      v-model="filters.operationId"
                      :plain="true"
                      :options="selectOperationDDL"
                      :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
          </b-col>
          
          
          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>

        <b-row class="mb-3">
          <b-col>
            <div class="d-flex align-items-center">
              <span class="text-muted">
                <strong>Total:</strong> {{ items.length }} contagens
                <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
              </span>
              <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
              <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
            </div>
          </b-col>
        </b-row>

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped
              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">

                

                  <b-card>

                      <b-row v-if="row.item.identificationUser">
                          <b-col class="small col-auto">Identificação: </b-col>
                          <b-col class="text-primary">[{{ row.item.identificationUser.username }}] {{ row.item.identificationUser.name }}</b-col>
                          <b-col class="small col-auto">Data: </b-col>
                          <b-col class="text-primary">{{ $utils.localDateTime(row.item.identificationDate) }}</b-col>
                          <b-col class="small col-auto">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b-col>
                          <b-col class="text-primary">&nbsp;&nbsp;&nbsp;</b-col>
                      </b-row>
                    
                      
                  </b-card>
              </template>
              
              <template v-slot:cell(originalValue)="data">
                  {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
              </template>

              <template v-slot:cell(paymentValue)="data">
                  {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
              </template>

              <template v-slot:cell(productDetail)="data">
                  <div v-if="data.item.product">
                    {{ data.item.product.code  }}<br><span class="text-primary">{{ data.item.product.description }}</span>
                  </div>
              </template>

              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
             
              <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="primary" @click="openEditModal(data.item)" class="mr-1 btn-brand" title="Editar" style="margin-bottom: 4px">
                    <i class="fa fa-edit"></i></b-button>
                    
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>


  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {label: null, st: 'A', _rowVariant: '', productCode: '', sectorName: null, operationName: null, count: null, productId: null, serial: null}
const newProduct = { typeName: null, typeId: null, code: null, umName: null, name: null, description: null}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch
  },
  data: () => {
    return {
      currentLabel: '',

      inventoryDDL: [],
      cancelModal: false,
      tabInfo: 'L',
      inventoryProductStatusDDL: [],
      productTypeDDL: [],
      sectorDDL: [],
      operationDDL: [],
      statusddl: [
        {
          text: '- Todos -',
          value: 0
        },
        {
          text: 'Ativo',
          value: 'A'
        },
        {
          text: 'Inativo',
          value: 'I'
        }
      ],
      companyDDL: [],

      isBusy: false,
      isLoadingMore: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        companyId: null,
        key: '',
        status: 0,
        sectorId: 0,
        operationId: 0,
        productTypeId: 0,
        inventoryProductStatusId: 0,
        inventoryId: 0,
        label: ''
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",
      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "40px" } },
        //{key: 'id' },
        //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
        {key: 'label', label: 'Etiqueta', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'product.typeName', label: 'Tipo', sortable: true, thStyle: { width: "150px" } },
        {key: 'productDetail', label: 'Item', sortable: true},
        {key: 'product.umName', label: 'U/M', sortable: true, class: 'text-center'},
        {key: 'locationName', label: 'Setor', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        {key: 'operationName', label: 'Op', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        //{key: 'count1', label: 'Cont. 1', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        //{key: 'count2', label: 'Cont. 2', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        //{key: 'count3', label: 'Cont. 3', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
        //{ key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
        //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
        //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
        //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
        //{key: 'description', label: 'Descrição', sortable: false },
        //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
        //{key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } }
        //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    incompleteFields: function() {
      console.log("Codigo: " + this.selectedItem.product + " Quantidade: " + this.selectedItem.count)
      return !((this.selectedItem.product) && (this.selectedItem.count && this.selectedItem.count != ''))
    },
  
    selectInventoryProductStatusDDL: function() {
      var list = [...this.inventoryProductStatusDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    selectProductTypeDDL: function() {
      var list = [...this.productTypeDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },

    selectSectorDDL: function() {
      var list = [...this.sectorDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Setor -' })
      return list
    },

    selectOperationDDL: function() {
      var list = [...this.operationDDL]
      list = list.sort((a,b) => (Number(a.text) > Number(b.text)) ? 1 : -1)
      list.unshift({ value: '0' , text: '- Operação -' })
      return list
    },

    totalRows: function () { return this.filteredItems.length },
    filteredItems() {
      try {
          return this.items.filter(item => {
            return (this.filters.key == '' || (
                item.product && (
                  this.$utils.filterString(item.product.code, this.filters.key)
                  || this.$utils.filterString(item.product.description, this.filters.key)
                  || this.$utils.filterString(item.product.typeName, this.filters.key)
                )
                //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                ))
                && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status )
                && (this.filters.label == '' || (
                this.$utils.filterString(item.label, this.filters.label)
                ) )
                && (this.filters.sectorId==0 || (Number(this.filters.sectorId) == Number(item.locationId)))
                //&& (this.filters.operationId==0 || (Number(this.filters.operationId) == Number(item.operationId)))
                //&& (this.filters.inventoryProductStatusId==0 || Number(this.filters.inventoryProductStatusId) == 3 || Number(this.filters.inventoryProductStatusId) == 5 || Number(this.filters.inventoryProductStatusId) == 4 )
                && ((item.user1 && item.user1.id == this.$store.state.currentUser.id) || (item.user2 && item.user2.id == this.$store.state.currentUser.id))
          })
      }
      catch(e) {
          return this.items;
      }
    },

    sectorObj() {
      if(this.sectorDDL) {
        var sector = this.$utils.findInArray(this.sectorDDL, 'value', this.filters.sectorId);
        if(sector && sector.label && sector.label != 'L')
          this.selectedItem.operationId = null
        return sector
      }
      return { text: '' };
    }
  },
  watch: {
    filteredItems() {
      var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
      if (this.currentPage > totalPages) {
        this.currentPage = 1;
      }
    },
    perPage() {
      var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
      if (this.currentPage > totalPages) {
        this.currentPage = 1;
      }
    }
  },
  methods: {

    async saveItem(currentItem) {

      var s = this;
      var postData = {...currentItem};

      //postData["companyId"] = s.filters.companyId
      postData["uid"] = this.$store.state.currentUser.id
      postData["sid"] = this.$store.state.currentUser.sid

      await axios.post(
          this.$store.state.ws_url + "/inventory/product/count",
          postData
      ).then(function() {
        s.selectedItem = {...newItem}
        s.selectedItem.label = null
        s.selectedItem.operationId  = null
        s.selectedItem.productCode = null
        s.selectedProduct = {...newProduct}
        s.refreshData();
      }
      ).catch(function (error) {
        console.log(error)
          toast ({
              type: VueNotifications.types.warn,
              title: 'Erro',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
          })        
      });
      
  },

  saveIdentification() {

      let msgError = [];

      if(!this.selectedItem)
        msgError.push("Etiqueta");

      if(!this.selectedItem.count)
          msgError.push("Quantidade");

      if(msgError.length > 0) {
          let msgErrorExt = "Verifique os campos: ";
          let msgErrorSep = "";
          msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

          toast ({
              type: VueNotifications.types.error,
              title: 'Aviso',
              message: msgErrorExt,
              timeout: 5000
          })
      }
      else {
          this.saveItem(this.selectedItem);
      }
  },

    onRowSelected(items) {
//        this.selected = items       
    },

    rowClicked(item) {
      //console.log("clique: " + (this.tableSelectable ? 'selecionavel' : 'não selecionavel'))
    },

    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },

    
    async getSector() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        await axios.get(
          this.$store.state.ws_url + "/stock/location/label/ddl?inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.sectorDDL = resp.data.obj;
            s.refreshData()
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    },

    async getOperation() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/stock/operation/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.operationDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 
    
    async getProductType() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/product/type/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.productTypeDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 

    async getInventoryProductStatus() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        await axios.get(
            this.$store.state.ws_url + "/inventory/product/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.inventoryProductStatusDDL = resp.data.obj;
        })            
        .catch(function(error) {
            console.log(error);
        });
        
    }, 

    async getLabel(code) {

      if(code && code.length > 0) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
       
        await axios.get(
            this.$store.state.ws_url + "/inventory/product/label?inventoryId=" + s.filters.inventoryId + "&label=" + this.$utils.numbersOnly(code) + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
            s.selectedItem = resp.data.obj
            if(s.selectedItem.product)
              s.selectedItem.productId = s.selectedItem.product.id 

            // Somente 
            if(s.selectedItem && (s.selectedItem.statusId != 1 && s.selectedItem.statusId != 3)) {
              s.selectedItem = {...newItem}
              toast ({
                type: VueNotifications.types.warn,
                title: 'Etiqueta',
                message: 'Etiqueta não identificada, finalizada ou em branco.',
                timeout: 5000
            })
            }
            
        })            
        .catch(function(error) {
            console.log(error);
            s.selectedItem.productId = null
            
            toast ({
                type: VueNotifications.types.warn,
                title: 'Etiqueta',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Etiqueta não identificada ou em branco.',
                timeout: 5000
            })       
            
        });
      
      }
      
    },

    async getInventory() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/stock/inventory/ddl?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
            s.inventoryDDL = resp.data.obj;

            if(s.inventoryDDL && s.inventoryDDL.length > 0) {
              // Mantém o inventoryId restaurado/atual se ele ainda existir na lista;
              // caso contrário (ou se não houver nenhum selecionado), usa o último.
              if(!s.filters.inventoryId || !s.inventoryDDL.some(i => i.value == s.filters.inventoryId)) {
                s.filters.inventoryId = Number(s.inventoryDDL[s.inventoryDDL.length-1].value)
              }
            }
            s.$utils.setInventoryContext(s.$store.state.config.storageName, s.filters.companyId, s.filters.inventoryId)
            s.getSector();
        })
        .catch(function(error) {
            console.log(error);
        });
        
    }, 

    async refreshData() {
      this.isBusy = true;
      this.isLoadingMore = false;

      var s = this;
      var currentUser = this.$store.state.currentUser;
      var page = 0;
      var pageSize = 100;
      var allItems = [];
      var hasMoreData = true;

      while (hasMoreData) {
        var url = this.$store.state.ws_url + "/inventory/product?inventoryId=" + s.filters.inventoryId + "&counterId=" + currentUser.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
        try {
          var resp = await axios.get(url);

          if (resp.data.obj && resp.data.obj.length > 0) {
            allItems = allItems.concat(resp.data.obj);

            // Atualiza a tabela com os dados carregados até o momento
            s.items = [...allItems];

            // Remove o loading após carregar a primeira página
            if (page === 0) {
              s.isBusy = false;
              // Se há mais páginas, mostra o spinner de loading adicional
              if (resp.data.obj.length === pageSize) {
                s.isLoadingMore = true;
              }
            }

            // Se retornou menos itens que o pageSize, não há mais páginas
            if (resp.data.obj.length < pageSize) {
              hasMoreData = false;
            } else {
              page++;
            }
          } else {
            // Sem mais dados
            hasMoreData = false;
          }
        } catch (error) {
          hasMoreData = false;
          toast({
            type: VueNotifications.types.error,
            title: 'Erro',
            message: 'Sem permissão de acesso. Verifique e tente novamente.',
            timeout: 3000
          });
        }
      }

      this.isBusy = false;
      this.isLoadingMore = false;
    },

    changeInventory() {
      this.$utils.setInventoryContext(this.$store.state.config.storageName, this.filters.companyId, this.filters.inventoryId)
      this.getSector()
    },

    changeCompany() {
      this.getOperation()
      this.getProductType()
      this.getInventoryProductStatus()
      this.getInventory()
    }
  },
  mounted: function() {
    this.companyDDL = this.$store.state.currentUser.companies

    var stored = this.$utils.getInventoryContext(this.$store.state.config.storageName)
    var validStoredCompany = stored && stored.companyId && this.companyDDL.some(c => c.value == stored.companyId)

    this.filters.companyId = validStoredCompany ? stored.companyId : this.$store.state.currentUser.companyId
    if(validStoredCompany && stored.inventoryId) {
      this.filters.inventoryId = stored.inventoryId
    }

    this.changeCompany()
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>